import CustomerService from "@/app/services/CustomerService.js"
import { types } from "@/app/types/types";

const state =
{
	[types.STATE_CUSTOMERS]: []
};

const getters =
{
	[types.GET_CUSTOMERS]: (state) =>
	{
		return state[types.STATE_CUSTOMERS]
	},

	[types.GET_CUSTOMER]: (state) => id =>
	{
		var customers = state[types.STATE_CUSTOMERS];

		for (const customer of customers)
		{
			if (customer.id == id)
				return customer;
		}

		return null
	}
};

const mutations =
{
	[types.MUTATE_LOAD_CUSTOMERS]: (state, payload) =>
	{
		state[types.STATE_CUSTOMERS] = payload
	},

	[types.MUTATE_ADD_CUSTOMER]: (state, payload) =>
	{
		state[types.STATE_CUSTOMERS].push(payload);
	},

	[types.MUTATE_UPDATE_CUSTOMER]: (state, payload) =>
	{
		//let index = state[types.STATE_CUSTOMERS].findIndex(customer => customer.id == payload.id)
		//state[types.STATE_CUSTOMERS].splice(index, 1, payload)
		let customer = state[types.STATE_CUSTOMERS].find((customer) => { return customer.id == payload.id });

		if (customer)
		{
			customer = payload
		}
	},

	[types.MUTATE_DELETE_CUSTOMER]: (state, payload) =>
	{
		//let index = state[types.STATE_CUSTOMERS].findIndex(customer => customer.id == payload.id)
		//state[types.STATE_CUSTOMERS].splice(index, 1)
		state[types.STATE_CUSTOMERS] = state[types.STATE_CUSTOMERS].filter((customer) => { return customer.id !== payload });
	}
};

const actions =
{
	[types.ACTION_GET_CUSTOMERS]: ({ commit }) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_GET_CUSTOMERS })
		
		return CustomerService.getCustomers().then(response =>
		{
			commit(types.MUTATE_LOAD_CUSTOMERS, response.data);
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_GET_CUSTOMERS, message: error });
		});
	},

	[types.ACTION_GET_CUSTOMER]: ({ commit }, payload) =>
	{
		log("ACTION_GET_CUSTOMER")

		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_GET_CUSTOMER, payload: payload })

		return CustomerService.getCustomer(payload).then(response =>
		{
			commit(types.MUTATE_UPDATE_CUSTOMER, response.data);
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_GET_CUSTOMER, message: error });
		});
	},

	[types.ACTION_ADD_CUSTOMER]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_ADD_CUSTOMER, payload: payload })

		return CustomerService.addCustomer(payload).then(response =>
		{
			commit(types.MUTATE_ADD_CUSTOMER, response.data);
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_ADD_CUSTOMER, message: error.response.statusText, payload: payload });
		});
	},

	[types.ACTION_UPDATE_CUSTOMER]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_UPDATE_CUSTOMER, payload: payload })

		return CustomerService.updateCustomer(payload).then(response =>
		{
			commit(types.MUTATE_UPDATE_CUSTOMER, payload);
			return response
		}).catch(error =>
		{
			let errorText = error && error.response && error.response.statusText ? error.response.statusText : error
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_UPDATE_CUSTOMER, message: errorText, payload: payload })
		});
	},

	[types.ACTION_DELETE_CUSTOMER]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_DELETE_CUSTOMER, payload: payload })

		return CustomerService.deleteCustomer(payload).then(response =>
		{
			commit(types.MUTATE_DELETE_CUSTOMER, { ...response.data, ...payload });
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_DELETE_CUSTOMER, message: error.response.statusText, payload: payload });
		});
	},

	[types.ACTION_EXPORT_EMAILS]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_EXPORT_EMAILS, payload: payload })

		return CustomerService.exportEmails(payload).then(response =>
		{
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_EXPORT_EMAILS, message: error.response.statusText, payload: payload });
		});
	},

	[types.ACTION_EXPORT_LOWRES_IMAGES]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_EXPORT_LOWRES_IMAGES, payload: payload })

		return CustomerService.exportLowResImages(payload).then(response =>
		{
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_EXPORT_LOWRES_IMAGES, message: error.response.statusText, payload: payload });
		});
	},

	[types.ACTION_EXPORT_ORDERS_DETAILS]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_EXPORT_ORDERS_DETAILS, payload: payload })

		return CustomerService.exportOrdersDetails(payload).then(response =>
		{
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_EXPORT_ORDERS_DETAILS, message: error.message });
			return error.response
		});
	},

	[types.ACTION_EXPORT_ORDERS_DELIVERYNOTES]: ({ commit }, payload) =>
	{
		commit(types.MUTATE_ADD_DEBUGLOG_ENTRY, { reference: types.ACTION_EXPORT_ORDERS_DELIVERYNOTES, payload: payload })

		return CustomerService.exportOrdersDeliveryNotes(payload).then(response =>
		{
			return response
		}).catch(error =>
		{
			commit(types.MUTATE_ADD_ERRORLOG_ENTRY, { reference: types.ACTION_EXPORT_ORDERS_DELIVERYNOTES, message: error.message })
			return error.response
		})
	}
}

export default
	{
		state,
		mutations,
		actions,
		getters
	}
